/**
 * Theme
 *
 */
export const KERNEL_THEME_SET = 'KERNEL_THEME_SET'

export function setKernelTheme(name, values) {
  return {
    type: KERNEL_THEME_SET,
    name,
    values,
  }
}
